import { createSelector, Selector } from 'reselect';
import { getRouterState } from '../../reducers';
import { State } from '../../../store/reducers';

export const selectPath: Selector<State, string> = createSelector(
  getRouterState,
  (routerState) => routerState.location.pathname
);
